<template>
  <div class="booking-interviews">
    <InterviewList :bookingId="bookingId">
      <template v-slot:footer>
        <BaseFooter>
          <ExpandedButtons>
            <Permissioned
              class="actions-bar"
              :vertical="isMobile"
              section="interviews"
            >
              <ViewInterviewFormatsAction />
              <ViewSelfScheduleInvitesAction />
              <ScheduleInterviewAction permission="schedule" />
            </Permissioned>
          </ExpandedButtons>
        </BaseFooter>
      </template>
    </InterviewList>
  </div>
</template>

<script>
import ScheduleInterviewAction from "@/views/bookings/BookingInterviews/components/actions/ScheduleInterviewAction";
import ViewInterviewFormatsAction from "@/views/bookings/BookingInterviews/components/actions/ViewInterviewFormatsAction";
import ViewSelfScheduleInvitesAction from "@/views/bookings/BookingInterviews/components/actions/ViewSelfScheduleInvitesAction";
import InterviewList from "@/views/bookings/BookingInterviews/components/InterviewList";
import BaseFooter from "@/components/common/BaseFooter";
import Permissioned from "@/components/common/Permissioned";
import ExpandedButtons from "@/components/common/ExpandedButtons";

export default {
  name: "BookingInterviews",
  components: {
    ScheduleInterviewAction,
    BaseFooter,
    ViewInterviewFormatsAction,
    ViewSelfScheduleInvitesAction,
    InterviewList,
    Permissioned,
    ExpandedButtons
  },
  computed: {
    bookingId() {
      return this.$route.params.id;
    }
  }
};
</script>

<style lang="scss"></style>
